import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import NativeBridge from '../../../core/utils/NativeBridge';
import styles from './PaymentPage.module.css';

/**
 * 결제 시작 페이지
 * Flutter WebView에서 호출되어 KSPAY로 리다이렉트
 */
const PaymentPage = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const initiatePayment = () => {
      try {
        // 파라미터 추출
        const transactionId = searchParams.get('transactionId');
        const amount = searchParams.get('amount');
        const goodsName = searchParams.get('goodsName') || '처방전 조제비';
        const userName = searchParams.get('userName');
        const userPhone = searchParams.get('userPhone');
        const userEmail = searchParams.get('userEmail') || '';
        const payMethod = searchParams.get('payMethod') || '1000000000'; // 기본: 신용카드

        // 필수 파라미터 검증
        if (!transactionId || !amount || !userName || !userPhone) {
          throw new Error('필수 결제 정보가 누락되었습니다.');
        }

        // Form POST로 KSPAY 호출
        submitKspayForm({
          transactionId,
          amount,
          goodsName,
          userName,
          userPhone,
          userEmail,
          payMethod,
        });
      } catch (err) {
        console.error('결제 초기화 실패:', err);
        setError(err.message);
      }
    };

    // 약간의 딜레이 후 실행 (DOM 준비)
    const timer = setTimeout(initiatePayment, 100);
    return () => clearTimeout(timer);
  }, [searchParams]);

  const submitKspayForm = (orderInfo) => {
    const { transactionId, amount, goodsName, userName, userPhone, userEmail, payMethod } = orderInfo;

    // KSPAY 설정
    const storeId = import.meta.env.VITE_KSPAY_STORE_ID || '2999199999';
    // KSPAY 결과를 Python 백엔드로 받고, React로 리다이렉트
    const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'https://pharm.mungpay.com:8000';
    const resultUrl = `${apiBaseUrl}/api/v1/payment/kspay/redirect`;

    // 동적 form 생성
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://kspay.ksnet.to/store/KSPayMobileV1.4/KSPayPWeb.jsp';
    form.acceptCharset = 'utf-8';

    const formData = {
      sndPaymethod: payMethod,
      sndStoreid: storeId,
      sndOrdernumber: transactionId,
      sndGoodname: goodsName,
      sndAmount: String(amount),
      sndOrdername: userName,
      sndMobile: userPhone,
      sndEmail: userEmail,
      sndCurrencytype: 'WON',
      sndInstallmenttype: '0:2:3:4:5:6:7:8:9:10:11:12',
      sndInteresttype: 'NONE',
      sndShowcard: 'C',
      sndCharSet: 'utf-8',
      sndEscrow: '0',
      sndGoodType: '1',
      sndReply: resultUrl,
    };

    // hidden input 추가
    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    // form submit
    document.body.appendChild(form);
    form.submit();
  };

  if (error) {
    return (
      <div className={styles.errorContainer}>
        <div className={styles.errorIcon}>!</div>
        <h2 className={styles.errorTitle}>결제 오류</h2>
        <p className={styles.errorMessage}>{error}</p>
        <button
          className={styles.button}
          onClick={() => NativeBridge.send('PAYMENT_ERROR', { error })}
        >
          돌아가기
        </button>
      </div>
    );
  }

  return (
    <div className={styles.loadingContainer}>
      <div className={styles.spinner} />
      <p className={styles.loadingText}>결제 페이지로 이동 중...</p>
    </div>
  );
};

export default PaymentPage;
